import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.blue.light25,
    padding: '2.626rem 0 0',
    [theme.breakpoints.up('md')]: {
      padding: '2.75rem 0',
    },
  },
  headline: {
    color: theme.palette.secondary.main,
    marginBottom: '1.875rem',
  },
  summary: {
    marginBottom: '3rem',
  },
  grid: {
    display: 'grid',
    gridGap: '10px',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gridAutoRows: '200px',
    gridAutoFlow: 'dense',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  gridContainer: {
    display: 'grid',
    gridGap: theme.spacing(1),
  },
  masonryGridBlock: ({ count }) => ({
    display: 'grid',
    gridGap: theme.spacing(1),
    gridTemplateRows: 'repeat(3,minmax(200px, 1fr))',
    gridTemplateColumns: '1fr',
    [theme.breakpoints.up('sm')]: {
      gridTemplateRows: 'repeat(2,minmax(220px, 1fr))',
      gridTemplateColumns: count > 1 ? 'repeat(2, minmax(0, 1fr))' : '1fr',
    },
    [theme.breakpoints.up('md')]: {
      gridTemplateRows: 'repeat(2,minmax(360px, 1fr))',
    },
    '&.reverse': {
      '& > div:nth-of-type(2)': {
        [theme.breakpoints.up('sm')]: {
          gridRowStart: 1,
        },
      },
    },
  }),
  masonryGridBlockItem: ({ count }) => ({
    '&:nth-of-type(1)': {
      [theme.breakpoints.up('sm')]: {
        gridRow: 'span 2 / span 2',
      },
    },
    '&:nth-of-type(2)': {
      [theme.breakpoints.up('sm')]: {
        gridRow: count < 3 ? 'span 2 / span 2' : 'initial',
      },
    },
  }),
}))

export default useStyles
